module.exports = __webpack_public_path__ + "img/bgyw@2x.351c1816.png";